<div class="flex flex-col size-container">
  <app-algolia-search-box/>
  @if (customer().loading) {
    <app-loading-icon [grey]="true"/>
  } @else if (customer().customer?.id) {
    <app-customer-info/>
  } @else {
    <app-need-help/>
  }
</div>
